import { QUERY_STATUS } from "constants/constants";
import Button from "core/buttons/button/Button";
import { FormattedMessage } from "react-intl";
import colors from "assets/styles/mixins/colors.scss";
import PropTypes from "prop-types";

const ModalFooter = ({
  onClose,
  onValidate,
  cancelButton = "cancel",
  validButton = "validate",
  disabled,
  modalType,
}) => {
  return (
    <div className="form-buttons">
      <Button
        className="btn-standard btn-outline"
        onClick={onClose}
        data-testid={`${modalType}_modal-cancel_btn`}
      >
        <FormattedMessage id={cancelButton} defaultMessage="Annuler" />
      </Button>
      <Button
        color="btn-standard gray-700"
        backgroundColor={disabled && colors.disabledGrey}
        onClick={onValidate}
        id="modal_button_form_validation"
        disabled={disabled === QUERY_STATUS.LOADING}
        data-testid={`${modalType}_modal-validate_btn`}
      >
        <FormattedMessage id={validButton} defaultMessage="Valider" />
      </Button>
    </div>
  );
};

ModalFooter.propTypes = {
  onClose: PropTypes.func,
  onValidate: PropTypes.func,
  cancelButton: PropTypes.string,
  validButton: PropTypes.string,
  disabled: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  modalType: PropTypes.string,
};

export default ModalFooter;
